import { lazy,Route } from '@tanstack/router'

import { newsRoute } from '.'

const News = lazy(() => import('../../pages/news'))

export const newsListRoute = new Route({
  getParentRoute: () => newsRoute,
  path: '/',
  component: News,
})
